export default function convertDate(str, locale) {
  if (!str) return null
  const date = new Date(str)
  const settings = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }
  return date
    .toLocaleString(locale, settings)
    .replace(/\//g, locale === 'pt-BR' ? '/' : '-')
}
